import React from "react";
import { Form, Grid, Loader } from "semantic-ui-react";
import { getDropdownOptions, handleAddressValue, handleFormChange } from "../../Helpers";
import { GlobalConstants } from "../constants/GlobalConstants";
import { FeatureFlags } from "../constants/LocalServerConstants";
import BCFormInput from "../ui/BCFormInput";
import BCMessage from "../ui/BCMessage";
import BCModal from "../ui/BCModal";
import BCModalHeaderBreadcrumb from "../ui/BCModalHeaderBreadcrumb";
import BCModalPrevNext from "../ui/BCModalPrevNext";
import BCValidationMessage from "../ui/BCValidationMessage";

const BPNewBrokerModals = ({ 
  newBroker, 
  setNewBroker, 
  newBrokerageName, 
  setNewBrokerageName, 
  brokerageInfo,
  isNewBrokerage,
  setBrokerageInfo,
  isBrokerModalOpen,
  setIsBrokerModalOpen,
  isBrokerageNameModalOpen,
  setIsBrokerageNameModalOpen,
  isBrokerageInfoModalOpen,
  setIsBrokerageInfoModalOpen,
  isModalMessage,
  setIsModalMessage,
  errorResponse,
  metadata,
  handleOpenBrokerageListModal,
  isGreaterThanMobile, 
  isModalLoading,
  similarBrokerageList,
  newBrokerageId,
  handleSelectBrokerage,
  handleOpenBrokerageInfoModal,
  handleBrokerModalSubmit,
  brokerColor, 
  isBrokerageDisabled = false,
  invalidProps }) => {
  const BrokerModalContent = <Form className="primary-form">
    <Grid>
      <Grid.Row className="application-row">
        <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="broker"
            label="First Name"
            placeholder="John"
            obj={newBroker}
            field="firstName"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, newBroker, setNewBroker)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="firstName" />
        </Grid.Column>
        <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="broker"
            label="Last Name"
            placeholder="Smith"
            obj={newBroker}
            field="lastName"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, newBroker, setNewBroker)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="lastName" />
        </Grid.Column>  
      </Grid.Row>
      <Grid.Row className="application-row">
        <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="broker"
            label="Phone"
            placeholder="2061234567"
            obj={newBroker}
            field="phone"
            fieldType="phone"
            inputType="text"
            required
            handleFormChange={(value, field) => handleFormChange(value, field, newBroker, setNewBroker, GlobalConstants.InputTypes.MASKED)}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="phone" />
        </Grid.Column>
        <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="broker"
            label="Email"
            placeholder="john.smith@gmail.com"
            obj={newBroker}
            field="brokerEmail"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, newBroker, setNewBroker, undefined, undefined, 100)}
            required
            disabled
          />
          <BCValidationMessage 
            invalidProps={invalidProps} 
            prop="custom-new-broker-invalid-email"
            propText="This email is invalid.."
          />
          <BCValidationMessage
            invalidProps={invalidProps} 
            prop="custom-broker-email"
            propText="You have already added a broker with this email."
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="application-row">
        <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="broker"
            label="Company Name"
            value={newBrokerageName}
            inputType="text"
            handleFormChange={(value) => setNewBrokerageName(value)}
            required
            disabled={isBrokerageDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="organizationName" />
        </Grid.Column>  
      </Grid.Row>
    </Grid>
  </Form>;

  const BrokerageInfoModalContent = <Form className="primary-form">
    <BCMessage
      animation={"fly down"}
      duration={750}
      visible={isModalMessage}
      transitionOnMount
      styles="full-width"
      onDismiss={() => setIsModalMessage(false)}
      errorResponse={errorResponse}
    />
    <Grid.Row className="application-row">
      <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
        {(isNewBrokerage || (!isNewBrokerage && brokerageInfo.entitySubTypeId)) && <BCFormInput
          labelClass="gmr-background-label"
          type="dropdown"
          label="Company Type"
          placeholder="Please Select..."
          obj={brokerageInfo}
          value={brokerageInfo.entitySubTypeId}
          field="entitySubTypeId"
          dropdownOptions={getDropdownOptions(metadata.entitySubTypes, ["id"], "name")}
          handleFormChange={(value, field) => handleFormChange(value, field, brokerageInfo, setBrokerageInfo)}
          required
          disabled={!isNewBrokerage}
        /> }
        <BCValidationMessage invalidProps={invalidProps} prop="entitySubTypeId" />
      </Grid.Column>  
      <Grid.Column width={16}>
        <BCFormInput
          label="Campany Address"
          inputKey="broker"
          labelClass="gmr-background-label"
          type={GlobalConstants.FormInputTypes.PLACES}
          placeDetailsObject={brokerageInfo}
          setPlaceDetailsObject={setBrokerageInfo}
          placeholder="1234 Main Street, Seattle, WA 98052, USA"
          defaultValue={handleAddressValue({
            address: brokerageInfo.physicalStreet,
            city: brokerageInfo.physicalCityName,
            state: brokerageInfo.physicalStateName,
            zip: brokerageInfo.physicalZipCode
          })}
          placeFields={["address", "city", "state", "county", "zip"]}
          placeFieldsNameOverrides={[
            {
              addressComponent: "address",
              field: "physicalStreet"
            },
            {
              addressComponent: "city",
              field: "physicalCityName"
            },
            {
              addressComponent: "state",
              field: "physicalStateName"
            },
            {
              addressComponent: "county",
              field: "physicalCountyName"
            },
            {
              addressComponent: "zip",
              field: "physicalZipCode"
            },
          ]}
          required
          disabled={!isNewBrokerage}
        />
        <BCValidationMessage invalidProps={invalidProps} prop="physicalZipCode" propText="Zip code is required." />
        <BCValidationMessage invalidProps={invalidProps} prop="physicalStreet" propText="Street name is required." />
      </Grid.Column>
      {isNewBrokerage && <Grid.Column width={16}>
        <BCFormInput
          labelClass="gmr-background-label"
          type="input"
          inputKey="broker"
          label="Address Line 2"
          placeholder="Apartment, suite, unit, building, floor, etc."
          obj={brokerageInfo}
          field="physicalAddressLine2"
          inputType="text"
          handleFormChange={(value, field) => handleFormChange(value, field, brokerageInfo, setBrokerageInfo)}
        />
      </Grid.Column>}
    </Grid.Row>
    {isNewBrokerage && <Grid.Row className="application-row">
      <Grid.Column width={16}>
        <BCFormInput 
          labelClass="gmr-background-label"
          type="checkbox"
          checkboxText="Company Address is same as Mailing Address"
          obj={brokerageInfo}
          field="isMailingSameAsPhysical"
          value={brokerageInfo.isMailingSameAsPhysical}
          handleFormChange={(value, field) => handleFormChange(value, field, brokerageInfo, setBrokerageInfo)}
        />
      </Grid.Column>
    </Grid.Row>}
    {brokerageInfo.isMailingSameAsPhysical === false && <React.Fragment>
      <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            label="Mailing Address"
            inputKey="broker"
            labelClass="gmr-background-label"
            type={GlobalConstants.FormInputTypes.PLACES}
            placeDetailsObject={brokerageInfo}
            setPlaceDetailsObject={setBrokerageInfo}
            placeholder="1234 Main Street, Seattle, WA 98052, USA"
            defaultValue={handleAddressValue({
              address: brokerageInfo.mailingStreet,
              city: brokerageInfo.mailingCityName,
              state: brokerageInfo.mailingStateName,
              zip: brokerageInfo.mailingZipCode
            })}
            placeFields={["address", "city", "state", "county", "zip"]}
            placeFieldsNameOverrides={[
              {
                addressComponent: "address",
                field: "mailingStreet"
              },
              {
                addressComponent: "city",
                field: "mailingCityName"
              },
              {
                addressComponent: "state",
                field: "mailingStateName"
              },
              {
                addressComponent: "county",
                field: "mailingCountyName"
              },
              {
                addressComponent: "zip",
                field: "mailingZipCode"
              },
            ]}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="mailingZipCode" propText="Zip code is required." />
          <BCValidationMessage invalidProps={invalidProps} prop="mailingStreet" propText="Street name is required." />
        </Grid.Column>
        <Grid.Column width={16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="broker"
            label="Address Line 2"
            placeholder="Apartment, suite, unit, building, floor, etc."
            obj={brokerageInfo}
            field="mailingAddressLine2"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, brokerageInfo, setBrokerageInfo)}
          />
        </Grid.Column>
      </Grid.Row>
    </React.Fragment>}
  </Form>;

  return (
    <React.Fragment>
      <BCModal
        isModalOpen={FeatureFlags.IS_BETA && isBrokerModalOpen}
        closeOnlyByButton={true}
        onClose={() => setIsBrokerModalOpen(false)}
        onOpen={() => setIsBrokerModalOpen(true)}
        header="Add New Broker"
        content={BrokerModalContent}
        actions={<BCModalPrevNext
          handleCancel={() => setIsBrokerModalOpen(false)}
          handleNext={() => handleOpenBrokerageListModal()}
          brokerColor={brokerColor}
        />}
      />
      <BCModal
        isModalOpen={FeatureFlags.IS_BETA && isBrokerageNameModalOpen}
        closeOnlyByButton={true}
        onClose={() => setIsBrokerageNameModalOpen(false)}
        onOpen={() => setIsBrokerageNameModalOpen(true)}
        header={<BCModalHeaderBreadcrumb modal="New Broker" subModal="Select Brokerage" setModal={setIsBrokerModalOpen} setSubModal={setIsBrokerageNameModalOpen} />}
        content={isModalLoading ? <Loader className="modal-loader" active inline="centered" size={"big"} /> : <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            labelClass="form-input-label"
            type="radio"
            radioClass="primary-modal-radio"
            inputKey="brokerage"
            inputArray={[...similarBrokerageList, { id: newBrokerageId, name: `None of the above, use "${newBrokerageName}"`}]}
            label="We found a few companies in our system that could be a match. Please select the best match."
            obj={brokerageInfo}
            field="organizationId"
            valueField="id"
            handleFormChange={(value, field) => handleSelectBrokerage(value, field)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="organizationId" />
        </Grid.Column>
      </Grid.Row>}
        actions={<BCModalPrevNext
          handlePrev={() => {setIsBrokerModalOpen(true); setIsBrokerageNameModalOpen(false);}}
          handleCancel={() => setIsBrokerageNameModalOpen(false)}
          handleNext={() => handleOpenBrokerageInfoModal()}
          brokerColor={brokerColor}
        />}
      />
      <BCModal
        isModalOpen={FeatureFlags.IS_BETA && isBrokerageInfoModalOpen}
        closeOnlyByButton={true}
        onClose={() => setIsBrokerageInfoModalOpen(false)}
        onOpen={() => setIsBrokerageInfoModalOpen(true)}
        header={<BCModalHeaderBreadcrumb modal="New Broker" subModal="Brokerage Information" setModal={setIsBrokerModalOpen} setSubModal={setIsBrokerageInfoModalOpen} />}
        content={BrokerageInfoModalContent}
        actions={<BCModalPrevNext
          handlePrev={() => {setIsBrokerageInfoModalOpen(false);  setIsBrokerageNameModalOpen(true);}}
          handleCancel={() => setIsBrokerageInfoModalOpen(false)}
          handleSave={() => handleBrokerModalSubmit()}
          brokerColor={brokerColor}
        />}
      />
    </React.Fragment>
  );
};

export default BPNewBrokerModals;
